// extracted by mini-css-extract-plugin
var _1 = "EmailReplyForm-modulecontent__knN6K";
var _2 = "EmailReplyForm-moduleformBody__GDXry EmailCreationForm-moduleformBody__hZad9";
var _3 = "EmailReplyForm-moduleshowTrimmedContentButton__gHHeb";
var _4 = "EmailReplyForm-moduleshowTrimmedContentButtonHidden__Ojl5e";
export { _1 as "content", _2 as "formBody", _3 as "showTrimmedContentButton", _4 as "showTrimmedContentButtonHidden" }
